import React from 'react';
import { Navigate } from 'react-router-dom';
import ApiClient from './utils/ApiClient';

const PrivateRoute = ({ children }) => {
    return ApiClient.isAuthenticated() ? children : <Navigate to="/" />;
};

export default PrivateRoute;
